export default {
    PELAYANANMEDIS: "PELAYANANMEDIS",
    PENUNJANGMEDIS: "PENUNJANGMEDIS",
}
